module.exports = __webpack_public_path__ + "5728365cf96d1b1877a4139af1808795.svg";